import React, { useEffect, useState } from 'react';
import { View } from "react-native"
import { BEEventApi, SquaresModule } from 'be-components';
import { Helmet } from 'react-helmet-async';
import { sq_getSquaresCompetitionById } from '../../store/actionsv1/comps';
import { V1_SHOW_AUTHENTICATE } from '../../store/actionsv1/types';
import { useDispatch, useSelector } from 'react-redux'; 
import { util_updateShare } from '../../store/actionsv1/utils';
import { SquaresCompetitionProps } from '../../store/types/tp_svc';

const SquaresPlayScreen = ({ route, navigation }:any) => {
    const [ competition, setCompetition ] = useState<any>();
    useEffect(() => {
        if(!route.params.sq_comp_id){ return }
        getDataFromServer(route.params.sq_comp_id)
    },[route.params?.sq_comp_id])

    const dispatch = useDispatch();
    const player = useSelector((state:any) => state.player.player, (left, right) => left?.player_id == right?.player_id);
    const getDataFromServer = async(sq_comp_id:string) => {
        const comp = await sq_getSquaresCompetitionById(sq_comp_id)
        setCompetition(comp)
    }

    const handleShareCompetition = async(squares_competition:SquaresCompetitionProps) => {

        dispatch(util_updateShare({
            share_key: `squares_${squares_competition.sq_comp_id}_share`,
            visible:true,
            title: `${squares_competition.sq_comp_name}`,
            body: 'Compete against me in BettorEdge auction squares for real money!',
            type_id: squares_competition.sq_comp_id,
            generator:'player',
            link_type: 'user_generated_link',
            link_sub_type: 'squares_link',
            redirect_url: `https://app.bettoredge.com/competition/squares/play/${squares_competition.sq_comp_id}`,
        }))
    }

    return (
        <View style={{flex:1}}>
            <View style={{ flex:1 }}>
                {competition ?
                <Helmet>
                    <title>{competition.sq_comp_name}</title>
                    <meta name='description' content={competition.sq_comp_description} />
                    <meta name='og:image' content={competition.image?.url} />
                </Helmet>
                :<></>}
                <SquaresModule
                    distinct_id=''
                    player_id={player?.player_id}
                    sq_comp_id={route.params.sq_comp_id}
                    onRequestAuthenticate={() => dispatch({ type:V1_SHOW_AUTHENTICATE, show_authenticate: { visible: true, hide_close:false, nav_out:false } })}
                    onShareCompetition={(squares_competition) => handleShareCompetition(squares_competition)}
                    onEvent={(ev) => BEEventApi.saveEvent(ev)}
                    onPlayerSelect={(player) => navigation.navigate('SocialStack', { screen:'SocialProfile', initial:false, params: { player_id: player.player_id } })}
                />
            </View>
        </View>
    )
}

export default SquaresPlayScreen